/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "OrderUserFacingStatus": {
                "nested": {
                  "UserFacingStatus": {
                    "values": {
                      "UNKNOWN": 0,
                      "CANCELED": 1,
                      "PROCESSING": 2,
                      "SHIPPED": 3,
                      "OUT_FOR_DELIVERY": 4,
                      "PARTIALLY_DELIVERED": 5,
                      "DELIVERED": 6,
                      "RETURNED_TO_SENDER": 7,
                      "SHIPPING_ERROR": 8,
                      "SHIPPED_WITH_ERRORS": 9,
                      "PARTIALLY_DELIVERED_WITH_ERRORS": 10,
                      "AWAITING_RETURN": 11,
                      "RETURNED": 12,
                      "RETURNED_AND_REFUNDED": 13,
                      "DECLINED": 14,
                      "DECLINED_REFUND_PENDING": 15,
                      "DECLINED_AND_REFUNDED": 16,
                      "CART": 17,
                      "PARTIALLY_SHIPPED": 18,
                      "SENT_TO_WAREHOUSE": 19,
                      "BACKORDERED": 20,
                      "EXPIRED": 21,
                      "RETAILER_PROCESSING": 22,
                      "READY_FOR_IN_STORE_PICKUP": 23,
                      "PARTIALLY_PICKED_UP": 24,
                      "PICKED_UP_FROM_STORE": 25,
                      "CANCELED_PICKUP_EXPIRED": 26
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.OrderUserFacingStatus?.nested?.UserFacingStatus) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE OrderUserFacingStatus @ squareup/solidshop/model/user_facing_status.proto at 8:1
 */
export const OrderUserFacingStatus = {};
/**
 * SOURCE UserFacingStatus @ squareup/solidshop/model/user_facing_status.proto at 9:3
 */
OrderUserFacingStatus.UserFacingStatus = $root.lookupEnum('squareup.solidshop.model.OrderUserFacingStatus.UserFacingStatus').values;
